<!-- ... existing code ... -->
<template>
    <div class="login-container">
        <div class="code-wrapper">
            <!-- <img src="/static/img/logo.png" width="200px" height="200px" /> -->
            <span class="logo-title">GEO大模型搜索优化在线询价</span>
            <van-field ref="codeField" class="code-input" v-model="code" placeholder="请输入校验码，点击确认后开始询价" />
            <button class="confirm-btn" @click="handleSubmit">确 认</button>
        </div>
    </div>
</template>

<script>
import { verifyCode } from "@/api/quotation";
export default {
    name: "Auth",
    data() {
        return {
            code: "",
        };
    },
    methods: {
        handleSubmit() {
            if (!this.code) {
                return this.$msg.error("请输入有效的校验码");
            }
            verifyCode(this.code).then((res) => {
                this.$router.push({
                    path: "/quotation?code=" + this.code,
                });
            }, this.$msg.error);
        },
    },
    computed: {
        //计算属性
    },
    created() {
        this.$router.push({
            query:{...this.$route.query},
            path: "/quotation",
        });
        //更换地址栏图标
        //this.changeFavicon('/static/img/quotation.ico');
        //this.addEnterEvent(this.handleSubmit, "inputCodeSubmit");
        window.hv = this;
    },
    watch: {},
    mounted() {
    },
    destroyed() {
        //组件释放
        this.delEnterEvent("inputCodeSubmit");
    },
    beforeRouteLeave(to, from, next) {
        // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
        // next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
        // next(false): 中断当前的导航。如果浏览器的 URL 改变了（可能是用户手动或者浏览器后退按钮），那么 URL 地址会重置到 from 路由对应的地址。
        // next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。
        // next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例，则导航会被终止且该错误会被传递给 router.onError() 注册过的回调。
        // 确保要调用 next 方法，否则钩子就不会被 resolved。

        //return next() // 下一步
        //return Promise.reject(true).delay(2000).then(()=>next(),()=>next(false));
        //return Promise.resolve(true).delay(2000).then(()=>next(),()=>next(false));
        return this.callBackEvent().then(
            () => next(),
            (e) => next(false)
        );
    },
};
</script>

<style scoped>
.login-container {
    width: 100%;
    height: 100vh;
    /* background: linear-gradient(135deg, #667eea, #764ba2); */
    background-color: #1e9dba;
    background-image: url("//7niu.deepagens.com/sd/rpt/img/bg3.jpg");
    background-size: cover; /* 或者使用 100% 100% 来确保覆盖整个元素 */
    background-position: center; /* 确保图片居中 */
    background-repeat: no-repeat; /* 防止图片重复 */
    /* background-color: #00b268; */
    /* background: #96e6a1;
    background-image: linear-gradient(-60deg, #16a085 0%, #96e6a1 100%); */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.code-wrapper {
    padding-top: 25vh;
    width: 70%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
}
.logo-title{
    color:#05608a;
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
    text-shadow: -1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;
}
.code-input {
    border-radius: 22px;
}
.code-input /deep/ .van-field__label {
    width: 4.5em;
}
.confirm-btn {
    width: 100%;
    border: 2px solid #fff;
    border-radius: 22px;
    background-color: transparent;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding: 12px;
}

.confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 255, 255, 0.15);
}

@media (max-width: 480px) {
}
</style>
@/api/quotation
